import { createFileRoute, notFound } from "@tanstack/react-router";
import { ApiError } from "@/api/client";
import {
  communityPostsInfiniteQuery,
  communityQuery,
} from "@/api/queries/communities";
import { CommunityPage } from "@/pages/communities/CommunityPage";
import { CommunityPageSkeleton } from "@/pages/communities/CommunityPageSkeleton";

const TABS = ["feed", "about", "members", "resources"] as const;
type CommunityTab = (typeof TABS)[number];

function validateSearch(search: Record<string, unknown>): { tab?: CommunityTab } {
  const tab = TABS.find((candidate) => candidate === search.tab);
  return tab ? { tab } : {};
}

export const Route = createFileRoute("/_app/c/$slug")({
  validateSearch,
  loader: async ({ context, params }) => {
    try {
      const community = await context.queryClient.ensureQueryData(communityQuery(params.slug));
      void context.queryClient.prefetchInfiniteQuery(communityPostsInfiniteQuery(params.slug));
      return community;
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) throw notFound();
      throw error;
    }
  },
  pendingComponent: CommunityPageSkeleton,
  component: CommunityPage,
});
